var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 36,
    height: 24,
    rx: 4,
    transform: "translate(48 492)",
    fill: "#ededed"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "en-flag",
    transform: "translate(-48 -492)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "united-states",
    transform: "translate(48 492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M35.379,112.276H.621A.626.626,0,0,1,0,111.644V88.908a.626.626,0,0,1,.621-.632H35.379a.626.626,0,0,1,.621.632v22.737A.626.626,0,0,1,35.379,112.276Z",
    transform: "translate(0 -88.276)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M36,90.122H0V88.908a.626.626,0,0,1,.621-.632H35.379a.626.626,0,0,1,.621.632v1.215Z",
    transform: "translate(0 -88.276)",
    fill: "#ff4b55"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 36,
    height: 1.846,
    transform: "translate(0 7.385)",
    fill: "#fb161b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 36,
    height: 1.846,
    transform: "translate(0 3.692)",
    fill: "#fb161b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M36,244.944H.621A.626.626,0,0,1,0,244.313V243.1H36Z",
    transform: "translate(0 -232.021)",
    fill: "#fb161b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 36,
    height: 1.846,
    transform: "translate(0 18.462)",
    fill: "#fb161b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M35.379,399.767H.621A.626.626,0,0,1,0,399.136v-1.215H36v1.215A.626.626,0,0,1,35.379,399.767Z",
    transform: "translate(0 -375.767)",
    fill: "#fb161b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 36,
    height: 1.846,
    transform: "translate(0 14.77)",
    fill: "#fb161b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M16.138,88.277H.621A.626.626,0,0,0,0,88.909v11.66a.626.626,0,0,0,.621.632H16.138a.626.626,0,0,0,.621-.632V88.909A.626.626,0,0,0,16.138,88.277Z",
    transform: "translate(0 -88.277)",
    fill: "#0b3c7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(1.002 1.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M14.993,108.01l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,14.993,108.01Z",
    transform: "translate(-14.253 -107.969)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M14.993,138.664l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,14.993,138.664Z",
    transform: "translate(-14.253 -136.43)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M14.993,169.318l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,14.993,169.318Z",
    transform: "translate(-14.253 -164.891)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M14.993,199.973l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066L14.938,201l-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,14.993,199.973Z",
    transform: "translate(-14.253 -193.352)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M14.993,230.626l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,14.993,230.626Z",
    transform: "translate(-14.253 -221.812)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M38.786,123.039l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,38.786,123.039Z",
    transform: "translate(-36.373 -121.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M38.786,153.693l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,38.786,153.693Z",
    transform: "translate(-36.373 -150.384)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M38.786,184.348l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,38.786,184.348Z",
    transform: "translate(-36.373 -178.845)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M38.786,215l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,38.786,215Z",
    transform: "translate(-36.373 -207.307)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M62.579,108.009l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,62.579,108.009Z",
    transform: "translate(-58.493 -107.969)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M62.579,138.664l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,62.579,138.664Z",
    transform: "translate(-58.493 -136.43)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M62.579,169.318l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,62.579,169.318Z",
    transform: "translate(-58.493 -164.891)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M62.579,199.973l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066L62.524,201l-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,62.579,199.973Z",
    transform: "translate(-58.493 -193.352)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M62.579,230.626l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,62.579,230.626Z",
    transform: "translate(-58.493 -221.812)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M86.373,123.039l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,86.373,123.039Z",
    transform: "translate(-80.614 -121.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M86.373,153.693l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,86.373,153.693Z",
    transform: "translate(-80.614 -150.384)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M86.373,184.348l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,86.373,184.348Z",
    transform: "translate(-80.614 -178.845)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M86.373,215l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,86.373,215Z",
    transform: "translate(-80.614 -207.307)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M110.166,108.009l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,110.166,108.009Z",
    transform: "translate(-102.733 -107.969)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M110.166,138.664l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,110.166,138.664Z",
    transform: "translate(-102.733 -136.43)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M110.166,169.318l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,110.166,169.318Z",
    transform: "translate(-102.733 -164.891)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M110.166,199.973l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066L110.11,201l-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,110.166,199.973Z",
    transform: "translate(-102.733 -193.352)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M110.166,230.626l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,110.166,230.626Z",
    transform: "translate(-102.733 -221.812)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M133.96,123.039l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,133.96,123.039Z",
    transform: "translate(-124.854 -121.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M133.96,153.693l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,133.96,153.693Z",
    transform: "translate(-124.854 -150.384)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M133.96,184.348l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,133.96,184.348Z",
    transform: "translate(-124.854 -178.845)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M133.96,215l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,133.96,215Z",
    transform: "translate(-124.854 -207.307)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M157.754,108.009l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,157.754,108.009Z",
    transform: "translate(-146.975 -107.969)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M157.754,138.664l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,157.754,138.664Z",
    transform: "translate(-146.975 -136.43)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M157.754,169.318l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,157.754,169.318Z",
    transform: "translate(-146.975 -164.891)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M157.754,199.973l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066L157.7,201l-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,157.754,199.973Z",
    transform: "translate(-146.975 -193.352)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M157.754,230.626l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,157.754,230.626Z",
    transform: "translate(-146.975 -221.812)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M181.547,123.039l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,181.547,123.039Z",
    transform: "translate(-169.095 -121.923)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M181.547,153.693l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,181.547,153.693Z",
    transform: "translate(-169.095 -150.384)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M181.547,184.348l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,181.547,184.348Z",
    transform: "translate(-169.095 -178.845)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M181.547,215l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,181.547,215Z",
    transform: "translate(-169.095 -207.307)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M205.341,108.009l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,205.341,108.009Z",
    transform: "translate(-191.216 -107.969)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M205.341,138.664l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,205.341,138.664Z",
    transform: "translate(-191.216 -136.43)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M205.341,169.318l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,205.341,169.318Z",
    transform: "translate(-191.216 -164.891)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M205.341,199.973l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,205.341,199.973Z",
    transform: "translate(-191.216 -193.352)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M205.341,230.626l.137.419.434,0a.06.06,0,0,1,.034.107l-.349.263.131.421a.059.059,0,0,1-.09.066l-.353-.257-.353.257a.059.059,0,0,1-.09-.066l.131-.421-.349-.263a.06.06,0,0,1,.034-.107l.434,0,.137-.419A.058.058,0,0,1,205.341,230.626Z",
    transform: "translate(-191.216 -221.812)",
    fill: "#f5f5f5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.a4629d2f68ea34f086b1696740bc93ed.svg";
export { ForwardRef as ReactComponent };